/**
 * PriorityFlag - Ícone de bandeira colorida para representar prioridade
 * 
 * Componente reutilizável que exibe uma bandeira (flag) com cor
 * associada ao nível de prioridade da tarefa.
 * 
 * @version 1.0.0
 * RELEASE: 2026-04-06 v1.0.0 - Criação inicial
 */

import { Flag } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Mapa de cores por prioridade */
const PRIORITY_FLAG_COLORS: Record<string, string> = {
  low: 'text-gray-400',
  normal: 'text-blue-500',
  medium: 'text-blue-500',
  high: 'text-orange-500',
  urgent: 'text-red-500',
};

/** Labels por prioridade */
export const PRIORITY_LABELS: Record<string, string> = {
  low: 'Baixa',
  normal: 'Normal',
  medium: 'Média',
  high: 'Alta',
  urgent: 'Urgente',
};

interface PriorityFlagProps {
  /** Nível de prioridade */
  priority: string;
  /** Tamanho do ícone em pixels (default 14) */
  size?: number;
  /** Classe CSS adicional */
  className?: string;
}

/**
 * Renderiza ícone de bandeira colorido conforme a prioridade
 */
export function PriorityFlag({ priority, size = 14, className }: PriorityFlagProps) {
  const colorClass = PRIORITY_FLAG_COLORS[priority] || PRIORITY_FLAG_COLORS.normal;

  return (
    <Flag
      className={cn(colorClass, className)}
      size={size}
      fill="currentColor"
      strokeWidth={1.5}
    />
  );
}
